export default "__VITE_ASSET__Dxiyc1Yk__"